import { render, staticRenderFns } from "./SimpleViewerModal.vue?vue&type=template&id=25d04369"
import script from "./SimpleViewerModal.vue?vue&type=script&lang=js"
export * from "./SimpleViewerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports